module.exports = "https://coursera_assets.s3.amazonaws.com/images/d6872dcec745f9a602ce62269662d56f.png";